// Popular country codes for the selector
// iso2 is the 2-letter ISO country code used for flag-icons library
export const countryCodes = [
  { code: '2', name: 'Egypt', iso2: 'eg' },
  { code: '1', name: 'United States', iso2: 'us' },
  { code: '44', name: 'United Kingdom', iso2: 'gb' },
  { code: '971', name: 'UAE', iso2: 'ae' },
  { code: '966', name: 'Saudi Arabia', iso2: 'sa' },
  { code: '965', name: 'Kuwait', iso2: 'kw' },
  { code: '974', name: 'Qatar', iso2: 'qa' },
  { code: '968', name: 'Oman', iso2: 'om' },
  { code: '973', name: 'Bahrain', iso2: 'bh' },
  { code: '962', name: 'Jordan', iso2: 'jo' },
  { code: '961', name: 'Lebanon', iso2: 'lb' },
  { code: '963', name: 'Syria', iso2: 'sy' },
  { code: '964', name: 'Iraq', iso2: 'iq' },
  { code: '970', name: 'Palestine', iso2: 'ps' },
  { code: '967', name: 'Yemen', iso2: 'ye' },
  { code: '218', name: 'Libya', iso2: 'ly' },
  { code: '216', name: 'Tunisia', iso2: 'tn' },
  { code: '213', name: 'Algeria', iso2: 'dz' },
  { code: '212', name: 'Morocco', iso2: 'ma' },
  { code: '249', name: 'Sudan', iso2: 'sd' },
  { code: '90', name: 'Turkey', iso2: 'tr' },
  { code: '98', name: 'Iran', iso2: 'ir' },
  { code: '92', name: 'Pakistan', iso2: 'pk' },
  { code: '91', name: 'India', iso2: 'in' },
  { code: '880', name: 'Bangladesh', iso2: 'bd' },
  { code: '60', name: 'Malaysia', iso2: 'my' },
  { code: '62', name: 'Indonesia', iso2: 'id' },
  { code: '86', name: 'China', iso2: 'cn' },
  { code: '81', name: 'Japan', iso2: 'jp' },
  { code: '82', name: 'South Korea', iso2: 'kr' },
  { code: '61', name: 'Australia', iso2: 'au' },
  { code: '64', name: 'New Zealand', iso2: 'nz' },
  { code: '49', name: 'Germany', iso2: 'de' },
  { code: '33', name: 'France', iso2: 'fr' },
  { code: '39', name: 'Italy', iso2: 'it' },
  { code: '34', name: 'Spain', iso2: 'es' },
  { code: '351', name: 'Portugal', iso2: 'pt' },
  { code: '31', name: 'Netherlands', iso2: 'nl' },
  { code: '32', name: 'Belgium', iso2: 'be' },
  { code: '41', name: 'Switzerland', iso2: 'ch' },
  { code: '43', name: 'Austria', iso2: 'at' },
  { code: '46', name: 'Sweden', iso2: 'se' },
  { code: '47', name: 'Norway', iso2: 'no' },
  { code: '45', name: 'Denmark', iso2: 'dk' },
  { code: '358', name: 'Finland', iso2: 'fi' },
  { code: '48', name: 'Poland', iso2: 'pl' },
  { code: '7', name: 'Russia', iso2: 'ru' },
  { code: '55', name: 'Brazil', iso2: 'br' },
  { code: '52', name: 'Mexico', iso2: 'mx' },
  { code: '54', name: 'Argentina', iso2: 'ar' },
  { code: '56', name: 'Chile', iso2: 'cl' },
  { code: '57', name: 'Colombia', iso2: 'co' },
  { code: '51', name: 'Peru', iso2: 'pe' },
  { code: '58', name: 'Venezuela', iso2: 've' },
  { code: '27', name: 'South Africa', iso2: 'za' },
  { code: '234', name: 'Nigeria', iso2: 'ng' },
  { code: '227', name: 'Niger', iso2: 'ne' },
  { code: '254', name: 'Kenya', iso2: 'ke' },
  { code: '233', name: 'Ghana', iso2: 'gh' },
  { code: '255', name: 'Tanzania', iso2: 'tz' }
]

// Default country code (Egypt)
export const DEFAULT_COUNTRY_CODE = '2'

// Get country name by code
export function getCountryByCode (code) {
  return countryCodes.find(c => c.code === code)
}

// Format phone number for display
export function formatPhoneDisplay (countryCode, phone) {
  return `+${countryCode} ${phone}`
}
